import { render, staticRenderFns } from "./ChatHistorial.vue?vue&type=template&id=6341d0aa"
import script from "./ChatHistorial.vue?vue&type=script&lang=js"
export * from "./ChatHistorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports